var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{class:_vm.hasError ? `error_error ${_vm.errorBtn ? 'error_btn' : ''}` : ''},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]),_c('div',{class:_vm.hasError
        ? '_custom_full_width custom_error'
        : `_custom_full_width ${_vm.errorBtn ? '' : 'hover'}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }